export const externalApplications = {
  DBB: "DBB"
}